__turbopack_context__.v({
  "connectionCard": "speedTest-module__pcMmnq__connectionCard",
  "connectionDetails": "speedTest-module__pcMmnq__connectionDetails",
  "connectionLabel": "speedTest-module__pcMmnq__connectionLabel",
  "connectionSub": "speedTest-module__pcMmnq__connectionSub",
  "connectionValue": "speedTest-module__pcMmnq__connectionValue",
  "errorBanner": "speedTest-module__pcMmnq__errorBanner",
  "gaugeContainer": "speedTest-module__pcMmnq__gaugeContainer",
  "gaugeSvg": "speedTest-module__pcMmnq__gaugeSvg",
  "goButton": "speedTest-module__pcMmnq__goButton",
  "goButtonBusy": "speedTest-module__pcMmnq__goButtonBusy",
  "goLabel": "speedTest-module__pcMmnq__goLabel",
  "goWrapper": "speedTest-module__pcMmnq__goWrapper",
  "pingLabel": "speedTest-module__pcMmnq__pingLabel",
  "pingRow": "speedTest-module__pcMmnq__pingRow",
  "pingValue": "speedTest-module__pcMmnq__pingValue",
  "progressBar": "speedTest-module__pcMmnq__progressBar",
  "progressFill": "speedTest-module__pcMmnq__progressFill",
  "progressPulse": "speedTest-module__pcMmnq__progressPulse",
  "resultsWrapper": "speedTest-module__pcMmnq__resultsWrapper",
  "runAgain": "speedTest-module__pcMmnq__runAgain",
  "speedNumber": "speedTest-module__pcMmnq__speedNumber",
  "speedTestPage": "speedTest-module__pcMmnq__speedTestPage",
  "speedUnit": "speedTest-module__pcMmnq__speedUnit",
  "speedValue": "speedTest-module__pcMmnq__speedValue",
  "tabularNums": "speedTest-module__pcMmnq__tabularNums",
  "testingLabel": "speedTest-module__pcMmnq__testingLabel",
});
